import { getShouldShowHereAndNowConnectYourCalendarFullScreen, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { HaNCalendarConsent } from "../shared/HaNCalendarConsent";
import { HaNContext } from "../shell/HaNContext";

export const RoomsList = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "rooms") return null;

  return <RoomsListContent />;
};

const RoomsListContent = () => {
  const isAskingForCalendar = useAppSelector(getShouldShowHereAndNowConnectYourCalendarFullScreen);

  if (!isAskingForCalendar) return null;

  return (
    <div className="flex flex-1 items-center justify-center p-5">
      <HaNCalendarConsent />
    </div>
  );
};
